/* Alpacas Foods — PLP: auto-submit de filtros/ordenação + drawer mobile.
   Usa filtros nativos do Shopify (Search & Discovery). Porta a UX de PLP.tsx. */
(function () {
  'use strict';
  // Auto-submit ao mudar filtro/ordenação.
  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('[data-facets-form]');
    if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
  });

  // Drawer de filtros (mobile).
  function setDrawer(open) {
    var d = document.querySelector('.alp-filters');
    var b = document.querySelector('.alp-filters__backdrop');
    if (d) d.classList.toggle('is-open', open);
    if (b) b.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.alp-plp__filter-btn')) setDrawer(true);
    if (e.target.closest('.alp-filters__close') || e.target.closest('.alp-filters__backdrop')) setDrawer(false);
  });
})();
